/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { updatePathWithTabs } from "../../utils/Routes";

import QC from "../Components/QC/QC";

import { getUser } from "../../utils/helpers";
import QcRulesTab from "../Components/QC/QcRulesTab";
import QcHistory from "../Components/QC/QcHistory/QcHistory";
// import RcaTracking from "../Components/QC/RcaTracking/RcaTracking";

const AntTabs = withStyles({
  root: {
    backgroundColor: "#F4F5F7",
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#494B83",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 160,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontSize: "14px",
    lineHeight: "24px",
    color: "#6B778C",
    fontFamily: ["Roboto Bold"].join(","),
    "&:hover": {
      color: "#494B83",
      opacity: 1,
    },
    "&$selected": {
      color: "#494B83",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#494B83",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  chem: {
    backgroundColor: "#F4F5F7",
  },
}));

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`qc-tabpanel-${index}`}
      aria-labelledby={`qc-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

TabPanel.defaultProps = {
  children: null,
};

function a11yProps(index) {
  return {
    id: `qc-tab-${index}`,
    "aria-controls": `qc-tabpanel-${index}`,
  };
}

export default function QcTab(props) {
  const classes = useStyles();
  const user = useMemo(() => getUser(), []);
  const history = useHistory();
  const page = "qc";
  const index = undefined;
  const currentPath = undefined;
  const tabs = useMemo(() => [
    {
      tabLabel: "Dashboard",
      route: "dashboard",
      permission: "view_dashboard_qc",
      component: (
        <div className="customTabQc">
          <QC />
        </div>
      ),
    },
    {
      tabLabel: "History",
      route: "history",
      permission: "view_history_tab_qc",
      component: (
        <div className="customTabQc">
          <QcHistory />
        </div>
      ),
    },
    {
      tabLabel: "Rules",
      route: "rules",
      permission: "view_rules_qc",
      component: (
        <div className="customTabQc">
          <QcRulesTab />
        </div>
      ),
    },
    // {
    //   tabLabel: "RCA",
    //   route: "rca",
    //   permission: "view_rca_qc",
    //   component: (
    //     <div className="customTabQc">
    //       <RcaTracking />
    //     </div>
    //   ),
    // },
  ], []);
  const authorizedTabs = useMemo(() => tabs.filter((item) => user.permissionMap[item.permission]).map((item, i) => ({ ...item, tabValue: i })), [tabs, user]);

  // Calculate initial tab value from URL to avoid rendering wrong tab first
  const getInitialTabValue = () => {
    const path = window.location.pathname;
    const matchingTab = authorizedTabs.find((item) => path === `/${page}/${item.route}`);
    return matchingTab ? matchingTab.tabValue : 0;
  };

  const [value, setValue] = React.useState(getInitialTabValue);
  const [activeTabInQC, setActiveTabInQC] = React.useState("");

  const onChangeTab = () => {
    setActiveTabInQC("");
  };

  const handleChange = useCallback((event, newValue) => {
    // Depending on the value of the tab, update the path
    updatePathWithTabs(currentPath, newValue, page, setValue, authorizedTabs, history);
    // Update the state
    setValue(newValue);
    if (activeTabInQC === 0) {
      onChangeTab();
    }
  }, [history, currentPath, activeTabInQC, authorizedTabs]);

  useEffect(() => {
    const path = window.location.pathname;
    // On refresh, makes sure the state is set correctly
    updatePathWithTabs(path, index, page, setValue, authorizedTabs, history);

    // Handles the case when the back button on the browser is clicked
    const unlisten = history.listen((location) => {
      updatePathWithTabs(location.pathname, index, page, setValue, authorizedTabs, history);
    });

    // Cleanup subscription on component unmount
    return () => {
      unlisten();
    };
  }, []); // eslint-disable-line

  const { activeTabInQC: valueFromProp } = props;
  return (
    <div className={classes.root}>
      <div className={classes.qc}>
        <AntTabs
          value={valueFromProp === 0 ? valueFromProp : value}
          onChange={handleChange}
          aria-label="ant tabs"
        >
          {authorizedTabs.map((item) => (<AntTab key={item.tabValue} label={item.tabLabel} {...a11yProps(item.tabValue)} />))}
        </AntTabs>
        {authorizedTabs.map((item) => (
          <TabPanel key={item.tabValue} value={value} index={item.tabValue}>
            {item.component}
          </TabPanel>
        ))}
      </div>
    </div>
  );
}
